import React, { Component } from "react";
import queryString from "query-string";

import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import InvoiceModal from "./components/InvoiceModal";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import {
  addInvoice,
  deleteInvoice,
  getInvoicesList,
  setStatuses,
  getInvoicesFilters,
  setInvoicesList,
} from "../../../store/invoices/actions";
import { getOffers } from "../../../store/offers/actions";
import DynamicFormFilterBetween from "../../../components/forms/DynamicFormFilterBetween";
import ModifiedMetaTags from "../../../components/ModifiedMetaTags";

class Invoices extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      viewAddInvoice: false,
      statuses: [
        { id: "ALL", name: "ALL" },
        { id: "NEW", name: "NEW" },
        { id: "PAID", name: "PAID" },
      ],
    };
  }

  componentDidMount() {
    this.props.getInvoicesFilters();
    let data = this.props.data;
    let parsedSearch = queryString.parse(this.props.history.location.search);
    let formattedSearch = {};

    for (const [key, value] of Object.entries(parsedSearch)) {
      if (value !== null) {
        formattedSearch[key] = value;
      }
    }

    this.props.history.push({
      search: queryString.stringify(formattedSearch),
    });

    data.date_filters = Object.assign(formattedSearch);
    // this.props.getInvoicesList(data);

    this.props.getOffers({
      ...this.props.offers,
      sizePerPage: 0,
      is_main: false,
    });
    this.props.setStatuses(this.state.statuses);
  }

  componentWillUnmount() {
    this.props.setInvoicesList({
      ...this.props.data,
      search: '',
      ordering: '',
      results: [],
    })
  }

  handleTableChange = data => {
    let currentSearch = queryString.parse(this.props.history.location.search);
    let formQueryString = queryString.stringify(
      Object.assign(currentSearch, {
        page: data.page,
        size: data.sizePerPage,
      })
    );
    this.props.history.push({ search: formQueryString });
    this.props.getInvoicesList(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddInvoiceModal = () => {
    this.setState(prevState => ({
      viewAddInvoice: !prevState.viewAddInvoice,
    }));
  };

  onFiltersChange = (filter, key, te) => {
    const { data } = this.props;
    let filteredData = {};
    let prevHistory = queryString.parse(this.props.history.location.search);
    let pageInitial = 1; //this.state.initial ? prevHistory.page : 1;

    switch (key) {
      case "total":
        let current_date_filters = {
          ...data.date_filters,
        };
        let formSearch = {};

        if (filter?.min) {
          current_date_filters.total_min = filter.min;
          formSearch.min = filter.min;
        } else {
          delete current_date_filters["total_min"];
          delete prevHistory['min'];
        }
        if (filter?.max) {
          current_date_filters.total_max = filter.max;
          formSearch.max = filter.max;
        } else {
          delete current_date_filters["total_max"];
          delete prevHistory['max'];
        }
        let total = {
          ...data,
          page: pageInitial,
          date_filters: {
            ...current_date_filters,
            page: pageInitial,
          },
        };
        let formatTotalQuery = queryString.stringify(
          Object.assign(prevHistory, { ...formSearch, page: pageInitial })
        );
        this.props.history.push({ search: formatTotalQuery });
        return this.props.getInvoicesList(total);
      case "bank_account":
        let bank_account = {
          ...data,
          page: pageInitial,
          date_filters: {
            ...data.date_filters,
            bank_account_number: filter.bank_account,
            page: pageInitial,
          },
        };
        let formatBankAccQuery = queryString.stringify(
          Object.assign(prevHistory, { ...filter, page: pageInitial })
        );
        this.props.history.push({ search: formatBankAccQuery });
        return this.props.getInvoicesList(bank_account);
      case "contractor":
        let contractor = {
          ...data,
          page: pageInitial,
          date_filters: {
            ...data.date_filters,
            contractor: filter.contractor,
            page: pageInitial,
          },
        };
        let formatContractorsQuery = queryString.stringify(
          Object.assign(prevHistory, { ...filter, page: pageInitial })
        );
        this.props.history.push({ search: formatContractorsQuery });
        return this.props.getInvoicesList(contractor);
      case "currency":
        let currency = {
          ...data,
          page: pageInitial,
          date_filters: {
            ...data.date_filters,
            currency: filter.currency,
            page: pageInitial,
          },
        };
        let formatCurrencyQuery = queryString.stringify(
          Object.assign(prevHistory, { ...filter, page: pageInitial })
        );
        this.props.history.push({ search: formatCurrencyQuery });
        return this.props.getInvoicesList(currency);
      case "status":
        let status = {};

        if (filter.status == "ALL") {
          let current = data.date_filters;
          let filter_current = filter;
          let prev = prevHistory;

          delete current["status"];
          delete filter_current["status"];
          delete prev["status"];

          status = {
            ...data,
            page: pageInitial,
            date_filters: {
              ...current,
              page: pageInitial,
            },
          };
          let formatStatusQuery = queryString.stringify(
            Object.assign(prev, { ...filter_current, page: pageInitial })
          );

          this.props.history.push({ search: formatStatusQuery });
        } else {
          status = {
            ...data,
            page: pageInitial,
            date_filters: {
              ...data.date_filters,
              status: filter.status,
              page: pageInitial,
            },
          };
          let formatStatusQuery = queryString.stringify(
            Object.assign(prevHistory, { ...filter, page: pageInitial })
          );
          this.props.history.push({ search: formatStatusQuery });
        }

        return this.props.getInvoicesList(status);
      default: {
        const { data } = this.props;
        let start_key = ``;
        let end_key = ``;

        if (key == "period") {
          start_key = `date_from_gte`;
          end_key = `date_to_lte`;
        } else {
          start_key = `${key}_gte`;
          end_key = `${key}_lte`;
        }

        let dt = {
          ...data,
          page: pageInitial,
          date_filters: {
            ...data.date_filters,
            [start_key]: filter.start_date,
            [end_key]: filter.end_date,
            page: pageInitial,
          },
        };

        for (let [item, value] of Object.entries(dt.date_filters)) {
          if (value !== null) {
            filteredData[item] = value;
          }
        }

        let formQueryString = queryString.stringify(
          Object.assign(prevHistory, { ...filteredData, page: pageInitial })
        );

        let formattedDateFilters = {};

        for (const [key, value] of Object.entries(dt.date_filters)) {
          if (value !== null) {
            formattedDateFilters[key] = value;
          }
        }

        dt.date_filters = formattedDateFilters;
        this.props.history.push({ search: formQueryString });
        return this.props.getInvoicesList(dt);
      }
    }
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.customer_name}"!`,
          onConfirm: () => {
            this.props.deleteInvoice(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length <= 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      return (
        <React.Fragment>
          {!!this.props.permissions?.["delete_invoice"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      if (row.status === "PAID") {
        return (
          <NameLink
            // style={{ color: "#34C38F" }}
            onClick={e => onClickRow(e, row)}
          >
            {row[label]}
          </NameLink>
        );
      } else if (row.status === "UNCOLLECTIBLE") {
        return (
          <NameLink
            // style={{ color: "#F46A6A" }}
            onClick={e => onClickRow(e, row)}
          >
            {row[label]}
          </NameLink>
        );
      } else {
        return (
          <NameLink onClick={e => onClickRow(e, row)}>{row[label]}</NameLink>
        );
      }
    };

    const clientFormatter = (cell, row) => {
      if (row.status === "PAID") {
        return (
          <NameLink
            // style={{ color: "#34C38F" }}
            onClick={e => onClickRow(e, row)}
          >
            {row.customer_name || "Empty"}
          </NameLink>
        );
      } else if (row.status === "UNCOLLECTIBLE") {
        return (
          <NameLink
            // style={{ color: "#F46A6A" }}
            onClick={e => onClickRow(e, row)}
          >
            {row.customer_name || "Empty"}
          </NameLink>
        );
      } else {
        return (
          <NameLink onClick={e => onClickRow(e, row)}>
            {row.customer_name || "Empty"}
          </NameLink>
        );
      }
    };

    const dateFormatter = (cell, row, label) => {
      if (row[label]?.length) {
        let date = new Date(row[label]).toJSON().split("T");
        return (
          <NameLink onClick={e => onClickRow(e, row)}>
            {`${date[0]} (${date[1].replace(/\..*/, "")}`})
          </NameLink>
        );
      }
    };

    const columns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
        formatter: function (cell, row) {
          return nameFormatter(cell, row, this.dataField);
        },
      },
      {
        dataField: "contractor",
        text: "Client",
        sort: true,
        formatter: function (cell, row) {
          return clientFormatter(cell, row);
        },
      },
      {
        dataField: "supplier_name",
        text: "Supplier",
        sort: true,
        formatter: function (cell, row) {
          return nameFormatter(cell, row, this.dataField);
        },
      },
      {
        dataField: "total_in_custom_currency",
        text: "Sum",
        sort: true,
        formatter: function (cell, row) {
          return nameFormatter(cell, row, this.dataField);
        },
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
        formatter: function (cell, row) {
          return nameFormatter(cell, row, this.dataField);
        },
      },
      {
        dataField: "created",
        text: "Created",
        sort: true,
        formatter: function (cell, row) {
          return dateFormatter(cell, row, this.dataField);
        },
      },
      {
        dataField: "date_due",
        text: "Due",
        sort: true,
        formatter: function (cell, row) {
          return nameFormatter(cell, row, this.dataField);
        },
      },
      {
        dataField: "date_paid",
        text: "Paid",
        sort: true,
        formatter: function (cell, row) {
          return dateFormatter(cell, row, this.dataField);
        },
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    const onClickRow = (e, row) => {
      this.props.history.push(`/invoices/${row.id}`);
    };

    const rowClasses = (row, rowIndex) => {
      let currentDate = new Date();
      let rowDate = new Date(row?.date_due);
      let classes = null;

      switch (row["status"]) {
        case "PAID":
          classes = "custom-table-bg--success";
          break;
        case "NEW":
          if (currentDate > rowDate) {
            classes = "custom-table-bg--warning";
          }
          break;
        default:
          classes = "";
          break;
      }

      return classes;
    };

    return (
      <React.Fragment>
        <InvoiceModal
          toggle={this.toggleViewAddInvoiceModal}
          isOpen={this.state.viewAddInvoice}
          data={this.props.data}
          addCampaignFormat={this.props.addInvoice}
        />
        <div className="page-content">
          <ModifiedMetaTags title="Invoices | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Invoices"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>
                  Are you sure want to delete this invoice?
                  <br /> If you are not sure, you can close this form
                </p>
                <p></p>
              </SweetAlert>
            )}

            {!!this.props.permissions?.["add_invoice"] && (
              <div>
                <Row>
                  <Col>
                    <div className="text-start gy-2 gx-1 d-flex float-end">
                      <Button
                        color="success"
                        style={{ padding: "10px", minWidth: "143px" }}
                        onClick={() => this.props.history.push(`/invoices/add`)}
                      >
                        Create invoice
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
            <DynamicFormFilterBetween
              onFiltersChange={this.onFiltersChange}
              filtersFields={[
                {
                  filterData: this.props.filter_data.bank_account_numbers || [],
                  title: "Bank account",
                  plug: "Bank account...",
                  filterType: "bank_account",
                },
                {
                  filterData: this.props.filter_data.contractors || [],
                  title: "Contractor",
                  plug: "Contractor...",
                  filterType: "contractor",
                },
                // {
                //   filterData: this.props.filter_data.currencies || [],
                //   title: "Currency",
                //   plug: "Currency...",
                //   filterType: "currency",
                // },
                {
                  filterData: this.props?.statuses,
                  title: "Status",
                  plug: "Status...",
                  filterType: "status",
                  hasSelectAll: false,
                  singleSelect: true,
                },
              ]}
              filtered_by={["bank_account", "contractor", "currency", "status"]}
              filtered_params={queryString.parse(
                this.props.history.location.search
              )}
              selectedDate={[]}
              dateFilters={[
                {
                  plug: "Total",
                  key: "total",
                  numRange: true,
                },
                {
                  plug: "Created",
                  key: "created",
                  filterType: ["created_gte", "created_lte"],
                  clearDate: true,
                  // onlyMonth: true,
                },
                {
                  plug: "Period",
                  key: "period",
                  filterType: ["date_from_gte", "date_to_lte"],
                  onlyMonth: true,
                },
                // {
                //   plug: "Date paid",
                //   key: "paid",
                //   filterType: ["date_paid__gte", "date_paid__lte"],
                // },
                // {
                //   plug: "Date due",
                //   key: "due",
                //   filterType: ["date_due__gte", "date_due__lte"],
                // },
              ]}
            />

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                      rowClasses={rowClasses}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;

  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

Invoices.propTypes = {
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  filter_data: PropTypes.object.isRequired,
  data: PropTypes.shape({
    date_filters: PropTypes.object.isRequired,
    page: PropTypes.number.isRequired,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  offers: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  statuses: PropTypes.arrayOf(PropTypes.string).isRequired,
  loading: PropTypes.bool.isRequired,
  getInvoicesList: PropTypes.func.isRequired,
  addInvoice: PropTypes.func.isRequired,
  deleteInvoice: PropTypes.func.isRequired,
  setStatuses: PropTypes.func.isRequired,
  getOffers: PropTypes.func.isRequired,
  getInvoicesFilters: PropTypes.func.isRequired,
  setInvoicesList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  offers: state.Offers.offers,
  data: state.InvoiceList.data,
  statuses: state.InvoiceList.statuses,
  filter_data: state.InvoiceList.filter_data,
  loading: state.InvoiceList.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getInvoicesList,
  setInvoicesList,
  addInvoice,
  deleteInvoice,
  getOffers,
  setStatuses,
  getInvoicesFilters,
})(Invoices);
